"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _styles = require("@mui/styles");
var _CustomSelect = _interopRequireDefault(require("./CustomSelect"));
var _CustomRadioGroup = _interopRequireDefault(require("./CustomRadioGroup"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _getResource = require("../../utilities/getResource");
var _material = require("@mui/material");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles() {
  return {};
};
var CustomCertifiedOrg = /*#__PURE__*/function (_Component) {
  function CustomCertifiedOrg(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomCertifiedOrg);
    _this = _callSuper(this, CustomCertifiedOrg, [props]);
    var value = {
      answer: '',
      vendor: ''
    };
    if (props.value) {
      var a = JSON.parse(props.value);
      if (a.length > 1) {
        value = {
          answer: a[0],
          vendor: (0, _lodash.find)(props.certifiedOrgs, {
            value: a[1]
          }),
          techID: a.length > 2 ? a[2] : props.certifiedOrgTechID
        };
      }
    }
    _this.state = {
      value: value
    };
    ['convertToValue', 'onVendorChange'].map(function (item) {
      return _this[item] = _this[item].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(CustomCertifiedOrg, _Component);
  return (0, _createClass2["default"])(CustomCertifiedOrg, [{
    key: "onAnswerChange",
    value: function onAnswerChange(v) {
      var _this$props = this.props,
        yesAnswerValue = _this$props.yesAnswerValue,
        certifiedOrgTechID = _this$props.certifiedOrgTechID;
      var val = (0, _lodash.cloneDeep)(this.state.value);
      console.log('custonCertifiedOrg', v);
      val.answer = v.target.value;
      if (val.answer !== yesAnswerValue) {
        val.vendor = '';
      }
      if (!val.techID || val.techID === '') {
        val.techID = certifiedOrgTechID;
      }
      this.setState({
        value: val
      });
      this.props.onChange(this.convertToValue(val));
    }
  }, {
    key: "onVendorChange",
    value: function onVendorChange() {
      var _this2 = this;
      var val = (0, _lodash.cloneDeep)(this.state.value);
      return function (event, value) {
        console.log('CustomCertifiedOrg', _this2.props.certifiedOrgs, value);
        val.vendor = value;
        if (!val.techID || val.techID === '') {
          val.techID = _this2.props.certifiedOrgTechID;
        }
        _this2.setState({
          value: val
        });
        _this2.props.onChange(_this2.convertToValue(val));
      };
    }
  }, {
    key: "convertToValue",
    value: function convertToValue(val) {
      return [JSON.stringify([val.answer, val.vendor.value, val.techID])];
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        answers = _this$props2.answers,
        resources = _this$props2.resources,
        language = _this$props2.language,
        yesAnswerValue = _this$props2.yesAnswerValue,
        certifiedOrgs = _this$props2.certifiedOrgs;
      var value = this.state.value;
      var blankOption = [{
        label: '',
        value: ''
      }];
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_CustomRadioGroup["default"], {
        name: "CustomCertifiedOrgAnswer",
        value: value.answer,
        direction: "vertical",
        onChange: function onChange(v) {
          return _this3.onAnswerChange(v);
        },
        answers: answers,
        resources: resources,
        language: language
      }), value.answer === yesAnswerValue && certifiedOrgs.length > 0 && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
        className: classes.titleOne
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Please select Digital Health Technology Partner')), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
        name: "CustomCertifiedOrgVendor",
        value: value.vendor,
        onChange: this.onVendorChange,
        options: blankOption.concat(certifiedOrgs),
        isMulti: false,
        disabled: false
      })));
    }
  }]);
}(_react.Component);
CustomCertifiedOrg.propTypes = {
  value: _propTypes["default"].any,
  onChange: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomCertifiedOrg);